module.exports = __webpack_public_path__ + "static/img/A3.9bf078cf.jpg";